export default "__VITE_ASSET__BYupHiBd__"